import React from 'react';
import TableWrapServerSide from '@/components/ui/tables/TableWrapServerSide';
import IsLoadingNotFound   from '@/components/ui/tables/IsLoadingNotFound';
import PermissionCheck     from '@/components/common/PermissionCheck';

/* ─────────────── BADGE COLORS ─────────────── */
const statusColors = {
  Present : 'bg-green-500  text-white',
  Absent  : 'bg-red-500    text-white',
  Leave   : 'bg-purple-500 text-white',
  Sick    : 'bg-indigo-500 text-white', // kept for legacy
  Casual  : 'bg-teal-500   text-white',
  Annual  : 'bg-pink-500   text-white',
  Other   : 'bg-gray-500   text-white',
  Off     : 'bg-blue-500   text-white',
  HalfDay : 'bg-orange-500 text-white',
  Late    : 'bg-yellow-500 text-black',
};

const fmtDate = ts => (ts ? new Date(ts).toLocaleDateString() : '');
const fmtTime = ts => {
  if (!ts) return '';
  const d = new Date(ts);
  return new Intl.DateTimeFormat(undefined, { hour: '2-digit', minute: '2-digit' }).format(d);
};

export default function DataTable({
  isLoading,
  tableColumn,
  dataSource,
  totalRecord,
  dataFilter,
  onChangePage,
  handleDrawerOpen,
  deleteRecord,
  handleStatusUpdate,
}) {
  return (
    <TableWrapServerSide
      tableColumnList={tableColumn}
      totalDataCount={totalRecord}
      initialPage={dataFilter.page}
      per_page={dataFilter.limit}
      onChangePage={onChangePage}
    >
      {dataSource.length ? (
        dataSource.map(row => (
          <tr key={row._id} className="db-table-body-tr">
            {tableColumn.map(col => {
              switch (col.name) {
                case 'Employee':
                  return (
                    <td key="emp" className="db-table-body-td">
                      {row.employee?.name ?? '—'}
                    </td>
                  );

                case 'Date':
                  return <td key="date" className="db-table-body-td">{fmtDate(row.date)}</td>;

                case 'Expected In Time':
                  return <td key="eIn" className="db-table-body-td">{fmtTime(row.expectedInTime)}</td>;

                case 'In Time':
                  return <td key="in" className="db-table-body-td">{fmtTime(row.inTime)}</td>;

                case 'Expected Out Time':
                  return <td key="eOut" className="db-table-body-td">{fmtTime(row.expectedOutTime)}</td>;

                case 'Out Time':
                  return <td key="out" className="db-table-body-td">{fmtTime(row.outTime)}</td>;

                case 'Status':
                  return (
                    <td key="status" className="db-table-body-td">
                      <span
                        className={`px-2 py-1 rounded text-xs font-medium ${
                          statusColors[row.status] ?? 'bg-gray-200 text-black'
                        }`}
                      >
                        {row.status}
                      </span>
                    </td>
                  );

                case 'Action':
                  return (
                    <td key="actions" className="db-table-body-td">
                      <div className="flex gap-1">
                        <PermissionCheck permission="view_attendance">
                          <button className="db-table-action view">
                            <i className="lab lab-view" />
                            <span className="db-tooltip">View</span>
                          </button>
                        </PermissionCheck>

                        {/* Optional edit drawer (kept commented)
                        {handleDrawerOpen && (
                          <PermissionCheck permission="update_attendance">
                            <button
                              className="db-table-action edit"
                              onClick={() => handleDrawerOpen(row._id)}
                            >
                              <i className="lab lab-edit-line" />
                              <span className="db-tooltip">Edit</span>
                            </button>
                          </PermissionCheck>
                        )} */}

                        {deleteRecord && (
                          <PermissionCheck permission="delete_attendance">
                            <button
                              className="db-table-action delete"
                              onClick={() => deleteRecord(row._id)}
                            >
                              <i className="lab lab-delete" />
                              <span className="db-tooltip">Delete</span>
                            </button>
                          </PermissionCheck>
                        )}

                        {/* NEW: always allow status change (if permitted) */}
                        {handleStatusUpdate && (
                          <PermissionCheck permission="update_attendance">
                            <button
                              className="db-table-action"
                              onClick={() => handleStatusUpdate(row)}
                            >
                              <i className="lab lab-edit-line" />
                              <span className="db-tooltip">Change&nbsp;Status</span>
                            </button>
                          </PermissionCheck>
                        )}
                      </div>
                    </td>
                  );

                default:
                  return null;
              }
            })}
          </tr>
        ))
      ) : (
        <IsLoadingNotFound
          isLoading={isLoading}
          colSpan={tableColumn.length}
        />
      )}
    </TableWrapServerSide>
  );
}
